module.exports = __webpack_public_path__ + "img/multiplesTrts.8fcdab2a.svg";